import { render, staticRenderFns } from "./InputAuthCode.vue?vue&type=template&id=21a2e594&scoped=true&"
import script from "./InputAuthCode.vue?vue&type=script&lang=js&"
export * from "./InputAuthCode.vue?vue&type=script&lang=js&"
import style0 from "./InputAuthCode.vue?vue&type=style&index=0&id=21a2e594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a2e594",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/uu264406/workDirectory/shingaku/reset_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21a2e594')) {
      api.createRecord('21a2e594', component.options)
    } else {
      api.reload('21a2e594', component.options)
    }
    module.hot.accept("./InputAuthCode.vue?vue&type=template&id=21a2e594&scoped=true&", function () {
      api.rerender('21a2e594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/contents/components/pages/signUp/common/InputAuthCode.vue"
export default component.exports